import * as React from 'react';
import { Link } from 'react-router';

import ReviewRepository from '../../repositories/ReviewRepository';
import Review from '../../models/Review';

import './reviews.less';

export default class Reviews extends React.Component<{}, { review: Review }> {

    static contextTypes: React.ValidationMap<any> = {
        review_repository: React.PropTypes.object
    }

    context: { review_repository: ReviewRepository };

    constructor( props: {}, context: any ) {
        super( props, context );

        this.state = { review: undefined };
    }

    componentDidMount() {
        this.find();
    }

    private find() {
        this.context.review_repository.
             findRandom().
             done( data => this.setState({ review: data }) );
    }

    render() {
        if ( !this.state.review )
            return null;

        return (
            <div className="reviews component">
              <div className="row">
                <div className="two wide column">
                  <div className="tripadvisor">
                    <img src="/images/tripadvisor.png" />
                  </div>
                </div>

                <div className="six wide column">
                  <div className="review">
                    <h2>"{ this.state.review.head }"</h2>
                    <p>
                      { this.state.review.body }
                    </p>
                    <div className="meta">
                      { this.state.review.author }
                      &nbsp;Reviewed { this.state.review.ratingDate.format('LL') }
                    </div>
                  </div>
                </div>

                <Link to="/rooms" className="four wide card widget column">
                  <img src="/images/champagne.jpg" alt="champagne" />
                  <h3>
                    All Our Rooms
                    <small>are available for your vacation rental!</small>
                  </h3>
                </Link>
              </div>
            </div>
        )
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/widgets/Reviews.tsx
 **/